import {useMemo} from 'react'
import {useTheme} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'

export const MedicalReportUneligibleType = ({isProjectAvailable}: {isProjectAvailable: boolean}) => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    const uneligibleCopy = useMemo(
        () =>
            isProjectAvailable
                ? {
                      title: t('medical_records:error_uneligible_report_project'),
                      subtitle: t('medical_records:error_uneligible_report_project_description')
                  }
                : {
                      title: t('medical_records:error_not_allowed_operation'),
                      subtitle: t('medical_records:error_not_allowed_operation_description')
                  },
        [isProjectAvailable]
    )

    return (
        <FormCardSection columnGap={4.5} columns={1} padding={3} style={{maxWidth: 496}}>
            <Flexbox direction="column" gap={2}>
                <AlertCircleIcon size={15} color={palette.orange['600']} />
                <Flexbox direction="column" gap={0.5}>
                    <Text weight="500" size="textMd" palette="orange" shade="800">
                        {uneligibleCopy.title}
                    </Text>
                    <Text size="textSm" palette="neutral" shade="500">
                        {uneligibleCopy.subtitle}
                    </Text>
                </Flexbox>
            </Flexbox>
        </FormCardSection>
    )
}
